import { lazy } from "react"; 
import { MOD_AUTH } from "@/configs/ModulesConfig";
const LoginPage = lazy(() => import("./login/LoginPage"));
const RegisterPage = lazy(() => import("./register/RegisterPage"));

const route = [
  {
    path: MOD_AUTH.login_path,
    element: <LoginPage />,
    auth: MOD_AUTH.auth,
  },
  {
    path: MOD_AUTH.register_path,
    element: <RegisterPage />,
    auth: MOD_AUTH.auth,
  },
];

export default route;
